import {takeEvery} from 'redux-saga/effects'

import {
  APPROVE_RECHECKING_RECORDS,
  CREATE_EAR_SERVICE,
  DELETE_EAR_SERVICE,
  DELETE_MANY_EAR_SERVICES,
  DELETE_RECHECKING_RECORD,
  EXPORT_RECHECKING_RECORDS,
  GET_RECHECKING_EAR_SERVICES,
  GET_RECHECKING_RECORDS,
  GET_RECHECKING_RECORD_OPTIONS,
  GET_STUDENT_RECHECKING_RECORD,
  SAVE_STUDENT_RECHECKING_RECORD,
  UPDATE_EAR_SERVICE,
} from '../../../Actions/Rechecking/ActionTypes/ApiActionTypes'
import fetchData from '../../SagaHelper'

function* recheckingSaga() {
  yield takeEvery(GET_RECHECKING_RECORDS, fetchData)
  yield takeEvery(GET_RECHECKING_RECORD_OPTIONS, fetchData)
  yield takeEvery(GET_STUDENT_RECHECKING_RECORD, fetchData)
  yield takeEvery(SAVE_STUDENT_RECHECKING_RECORD, fetchData)
  yield takeEvery(APPROVE_RECHECKING_RECORDS, fetchData)
  yield takeEvery(DELETE_RECHECKING_RECORD, fetchData)
  yield takeEvery(EXPORT_RECHECKING_RECORDS, fetchData)

  yield takeEvery(GET_RECHECKING_EAR_SERVICES, fetchData)
  yield takeEvery(CREATE_EAR_SERVICE, fetchData)
  yield takeEvery(UPDATE_EAR_SERVICE, fetchData)
  yield takeEvery(DELETE_EAR_SERVICE, fetchData)
  yield takeEvery(DELETE_MANY_EAR_SERVICES, fetchData)
}

export default recheckingSaga
